module.exports = __webpack_public_path__ + "static/media/A23_CNG.434e857a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/A23_CNG.jpg
// module id = 1486
// module chunks = 0